<ap-content [value]="'siteLayout.footer' | htmlContent">
</ap-content>
